import axiosHttpRequest from "../axios";

//Get QuotationFromSupplier
async function getQuotationFromSupplierListService(endpoint, configheaders) {
    const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParams(
      endpoint,
      configheaders
    );
  
    let serviceData = serviceResponse.data;
    let listViewData = [];
    if (serviceData.issuccess && serviceData.Records) {
      listViewData = serviceData.Records;
    }
    return listViewData;
  }

  async function saveQuotaionFromSupplierService(
    endpoint,
    postdata,
    configheaders
  ) {
    const serviceResponse = await axiosHttpRequest.execPostRequest(
      endpoint,
      postdata,
      configheaders
    );
  
    return serviceResponse;
  }


async function searchQuotaionFromSupplierService(endpoint, queryparams, configheaders) {
    const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

    let serviceData = serviceResponse.data;
    let listViewData = [];
    let listViewDataObj = {};
    let listViewInfo = {};
    if (serviceData.issuccess && serviceData.Records) {
        listViewData = serviceData.Records;
    }
    listViewInfo.records = listViewData;
    listViewInfo.paginationInfo = serviceData.paginationinfo;
    return listViewInfo;
}


//  PO TO Supplier

async function savePOToSupplierService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}



async function searchPOToSupplierService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
      listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}


//  Inspection Agency

async function saveInspectionAgencyService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}



async function searchInspectionAgencyService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
      listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

//  delivery confirmation

async function saveDeliveryConfirmationService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}



async function searchDeliveryConfirmationService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
      listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}


//  Rake Manufacturing

async function saveRakeManufacturingService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}



async function searchRakeManufacturingService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
      listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}


//  Rake Manufacturing

async function saveRakeCommissioningService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}



async function searchRakeCommissioningService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
      listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}


async function searchRakeInductionListService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
      listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

// Spare Wagon Delivery

async function saveSpareWagonDeliveryService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}


async function getSpareWagonDeliveryService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
      listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

// Spare Wagon Commissioning

async function saveSpareWagonCommissioningService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function getSpareWagonCommissioningService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
      listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}


  export default {
    getQuotationFromSupplierListService,
    saveQuotaionFromSupplierService,
    searchQuotaionFromSupplierService,
    savePOToSupplierService,
    searchPOToSupplierService,
    saveInspectionAgencyService,
    searchInspectionAgencyService,
    saveDeliveryConfirmationService,
    searchDeliveryConfirmationService,
    saveRakeManufacturingService,
    searchRakeManufacturingService, 
    saveRakeCommissioningService,
    searchRakeCommissioningService,
    searchRakeInductionListService,
    saveSpareWagonDeliveryService,
    saveSpareWagonCommissioningService,
    getSpareWagonCommissioningService,
    getSpareWagonDeliveryService
  };